import { render, staticRenderFns } from "./WelcomeDialog.vue?vue&type=template&id=736b0129&scoped=true"
import script from "./WelcomeDialog.vue?vue&type=script&lang=js"
export * from "./WelcomeDialog.vue?vue&type=script&lang=js"
import style0 from "./WelcomeDialog.vue?vue&type=style&index=0&id=736b0129&prod&scoped=true&lang=css"
import style1 from "./WelcomeDialog.vue?vue&type=style&index=1&id=736b0129&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736b0129",
  null
  
)

export default component.exports